import { render, staticRenderFns } from "./InventoryP.vue?vue&type=template&id=0b5c2ab2&scoped=true"
import script from "./InventoryP.vue?vue&type=script&lang=js"
export * from "./InventoryP.vue?vue&type=script&lang=js"
import style0 from "./InventoryP.vue?vue&type=style&index=0&id=0b5c2ab2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c2ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5c2ab2')) {
      api.createRecord('0b5c2ab2', component.options)
    } else {
      api.reload('0b5c2ab2', component.options)
    }
    module.hot.accept("./InventoryP.vue?vue&type=template&id=0b5c2ab2&scoped=true", function () {
      api.rerender('0b5c2ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/InventoryP.vue"
export default component.exports